import { useState } from "react";
import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { db } from "../../firebase/config";
import { questions } from "./Cuestionario";
import DiagnosticResult from "./DiagnosticoResult";
import NavBar from "../../Components/NavBar/NavBar";



function DiagnosticTest() {
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [answers, setAnswers] = useState([]);
  const [selected, setSelected] = useState(null);

  const [finished, setFinished] = useState(false);
  const [saving, setSaving] = useState(false);

  const question = questions[currentQuestion];

  const handleAnswer = (option) => {
    setSelected(option);
  };

  const nextQuestion = async () => {
    if (!selected) return;

    const newAnswers = [
      ...answers,
      {
        questionId: question.id,
        question: question.question,
        answer: selected.text,
        score: selected.score,
        category: selected.category || null,
      },
    ];

    setAnswers(newAnswers);
    setSelected(null);

    if (currentQuestion < questions.length - 1) {
      setCurrentQuestion(currentQuestion + 1);
      return;
    }

    await saveResult(newAnswers);
  };

  const saveResult = async (finalAnswers) => {
    try {
      setSaving(true);

      const totalScore = finalAnswers.reduce(
        (total, answer) => total + answer.score,
        0
      );

      await addDoc(collection(db, "diagnosticos"), {
        answers: finalAnswers,
        totalScore,
        totalQuestions: questions.length,
        createdAt: serverTimestamp(),
      });

      setFinished(true);
    } catch (error) {
      console.error("Error guardando diagnóstico:", error);

      alert(
        "No pudimos guardar el diagnóstico. Revisá tu conexión e intentá nuevamente."
      );
    } finally {
      setSaving(false);
    }
  };

  if (finished) {
    return <DiagnosticResult answers={answers} />;
  }

  const progress = ((currentQuestion + 1) / questions.length) * 100;

  return (<>
     <NavBar/>
    <section className="diagnostic-section">
       
      <div className="diagnostic-container">

        <div className="diagnostic-header">
          <span className="diagnostic-label">
            TEST DE DIAGNÓSTICO EMPRESARIAL
          </span>

          <h1 className="diagnostic-titulo">
            ¿Tu empresa está preparada
            <span> para crecer?</span>
          </h1>

          <p className="diagnostic-parrafo">
            Descubrí en 3 minutos qué tan organizada, digitalizada y
            preparada está tu empresa para dar el próximo paso.
          </p>
        </div>

        <div className="diagnostic-card">

          <div className="progress-wrapper">

            <div className="progress-info">
              <span>
                Pregunta {currentQuestion + 1} de {questions.length}
              </span>

              <span>{Math.round(progress)}%</span>
            </div>

            <div className="progress-bar">
              <div
                className="progress-fill"
                style={{ width: `${progress}%` }}
              />
            </div>

          </div>

          <div className="question-container">

            <div className="question-number">
              {String(question.id).padStart(2, "0")}
            </div>

            <h2>{question.question}</h2>

            <div className="answers">

              {question.options.map((option, index) => (
                <button
                  key={index}
                  className={`answer ${
                    selected?.text === option.text
                      ? "answer-selected"
                      : ""
                  }`}
                  onClick={() => handleAnswer(option)}
                >
                  <span className="answer-letter">
                    {String.fromCharCode(65 + index)}
                  </span>

                  <span className="answer-text">
                    {option.text}
                  </span>
                </button>
              ))}

            </div>

            <button
              className="next-button"
              disabled={!selected || saving}
              onClick={nextQuestion}
            >
              {saving
                ? "Guardando..."
                : currentQuestion === questions.length - 1
                ? "Ver mi diagnóstico"
                : "Continuar →"}
            </button>

          </div>

        </div>

      </div>
    </section>
    </>
  );
}

export default DiagnosticTest;